module.exports = __webpack_public_path__ + "static/media/carnival_style_rendering_for_bbq_restaurant_2016.a11b5cd3.webp";